import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFormulate from '@braid/vue-formulate'
import VueFormulatei18nFa from "@/i18n/VueFormulate/fa"

import * as VueGoogleMaps from "vue2-google-maps";
import Rules from "@/validation/Rules";
import TitleMixin from "@/mixins/TitleMixin";

Vue.config.productionTip = false

const moment = require('jalali-moment');
moment.locale("fa-IR");
Vue.use(require('vue-jalali-moment'), {
    moment
});

Vue.use(VueFormulate, {
    plugins: [VueFormulatei18nFa],
    locale: 'fa',
    rules: Rules
});

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBMLceiPmOZjqPFVW67MJ8M1WRcJ6Izd1I",
        libraries: "places"
    },
    installComponents: true
});

Vue.mixin(TitleMixin);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#vue-app')
